import * as React from 'react';

import { MessageContext } from '../../utils/messageContext';
import { EMessageType } from '../../types/messageType';
import { TMessage, TOutcomingStatus } from '../../types/messages';

type TMessageProviderProps = {
  message: TMessage & { status: TOutcomingStatus };
  messageId: string;
  chatId: string;
  messageType: EMessageType;
  isLastInChain: boolean;
  isFirstUserPhrase: boolean;
  messageRef: React.RefObject<HTMLDivElement | null>;
  cancelLongPress: VoidFunction;
};

export const MessageProvider: React.FC<React.PropsWithChildren<TMessageProviderProps>> = ({
  message,
  messageId,
  chatId,
  messageType,
  isLastInChain,
  isFirstUserPhrase,
  messageRef,
  cancelLongPress,
  children,
}) => {
  const contextValue = React.useMemo(
    () => ({
      message,
      messageId,
      chatId,
      messageType,
      isLastInChain,
      isFirstUserPhrase,
      messageRef,
      cancelLongPress,
    }),
    [message, messageId, chatId, messageType, isLastInChain, isFirstUserPhrase, messageRef, cancelLongPress],
  );

  return <MessageContext.Provider value={contextValue}>{children}</MessageContext.Provider>;
};
